import { SET_GOLOBAL_THEME_MODE } from "../actions/type.action";
const initialState = {
  themeMode: 'light',
};

export const navBarReducer = (state = initialState, action) => {
  switch (action.type) {
  case SET_GOLOBAL_THEME_MODE:
    return {
      ...state,
      themeMode: action.payload,
    };

  default:
    return state;
  }
};
